define.alias("shared/components/shared/plan-recommendation/steps/profiles", "settings/components/shared/plan-recommendation/steps/profiles");